exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Payment__root,\n.DS__Payment__method,\n.DS__Payment__disable-pointer-events {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n  .DS__Payment__root {\n  display: block;\n  max-width: 624px;\n}\n\n  @media (max-width: 767px) {.DS__Payment__root {\n    width: 100%\n}\n  }\n\n.DS__Payment__method {\n  display: block;\n  margin-bottom: 12px;\n}\n\n.DS__Payment__method h5 {\n    margin-bottom: 10px;\n  }\n\n.DS__Payment__disable-pointer-events {\n  pointer-events: none;\n  cursor: default;\n  -webkit-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n/* Fix render iOS 14 Safari */\n\n@media (max-width: 767px) {\n  .DS__Payment__info,\n  .DS__Payment__fields,\n  .DS__Payment__method {\n    -webkit-transform: translateZ(0);\n            transform: translateZ(0);\n  }\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__Payment__root",
	"method": "DS__Payment__method",
	"disable-pointer-events": "DS__Payment__disable-pointer-events",
	"info": "DS__Payment__info",
	"fields": "DS__Payment__fields"
};